import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { depositService } from '../services/depositService';

export const useDeposit = () => {
  const { user, token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successDetails, setSuccessDetails] = useState(null);

  // ✅ NEW: Get admin-controlled deposit page settings (bank warning banner)
  const getDepositSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await depositService.getDepositSettings();
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // ✅ Get deposit description
  const getDepositDescription = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 Fetching deposit description...');
      
      const description = await depositService.getDepositDescription();
      console.log('✅ Deposit description received:', description);
      return description;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getBankAccounts = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('🔍 Fetching bank accounts...');

      const accounts = await depositService.getBankAccounts();
      console.log('✅ Bank accounts received:', accounts);
      return accounts;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const getCryptoWallets = async (params = {}) => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 Fetching crypto wallets with params:', params);
      
      const wallets = await depositService.getCryptoWallets(params);
      console.log('✅ Crypto wallets received:', wallets);
      return wallets;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createCryptoDeposit = async (depositData) => {
    try {
      setLoading(true);
      setError(null);
      setIsSuccess(false);
      setSuccessDetails(null);
      
      console.log('📤 Creating crypto deposit with data:', depositData);
      const deposit = await depositService.createCryptoDeposit(depositData);
      console.log('✅ Crypto deposit created:', deposit);
      
      return deposit;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const createBankDeposit = async (depositData) => {
    try {
      setLoading(true);
      setError(null);
      setIsSuccess(false);
      setSuccessDetails(null);
      
      console.log('📤 Creating bank deposit with data:', depositData);
      const deposit = await depositService.createBankDeposit(depositData);
      console.log('✅ Bank deposit created:', deposit);
      
      return deposit;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Function to show success modal
  const showSuccess = (details = {}) => {
    console.log('🎉 Showing success modal with details:', details);
    setSuccessDetails(details);
    setIsSuccess(true);
  };

  // Function to hide success modal
  const hideSuccess = () => {
    console.log('👋 Hiding success modal');
    setIsSuccess(false);
    setSuccessDetails(null);
  };

  return {
    loading,
    error,
    isSuccess,
    successDetails,
    getDepositSettings,
    getDepositDescription,
    getBankAccounts,
    getCryptoWallets,
    createCryptoDeposit,
    createBankDeposit,
    showSuccess,
    hideSuccess
  };
};